package org.dronda.app.web.ui.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Text

/**
 * A modal panel over a dimmed backdrop. Clicking the backdrop calls [onDismiss].
 */
@Composable
fun Dialog(
    title: String,
    onDismiss: () -> Unit,
    content: @Composable () -> Unit,
) {
    Div(
        Modifier
            .fillMaxWidth()
            .height(100.percent)
            .backgroundColor(AppColors.scrim)
            .onClick { onDismiss() }
            .toAttrs {
                style {
                    property("position", "fixed")
                    property("top", "0")
                    property("left", "0")
                    property("z-index", "1000")
                    property("display", "flex")
                    property("justify-content", "center")
                    property("align-items", "center")
                }
            }
    ) {
        Div(
            Modifier
                .backgroundColor(AppColors.surface)
                .borderRadius(8.px)
                .padding(2.cssRem)
                .onClick { it.stopPropagation() }
                .toAttrs {
                    style {
                        property("width", "400px")
                        property("max-width", "calc(100vw - 2rem)")
                        property("box-sizing", "border-box")
                    }
                }
        ) {
            H3(Modifier.fontWeight(FontWeight.Bold).fontSize(1.25.cssRem).padding(bottom = 1.cssRem).toAttrs()) {
                Text(title)
            }
            content()
        }
    }
}
